/* eslint-disable max-classes-per-file */
import React from 'react'
import AppContext from '../contexts/AppContext'

// prettier-ignore
export class ContextConsumerComponent<P = {}, S = {}> extends React.Component<P, S> {
  static contextType = AppContext
}

export class BindingContextConsumerComponent<
  P = {},
  S = {},
> extends ContextConsumerComponent<P, S> {
  static contextType = AppContext
}
